import Divider from './Divider';
import { DividerProps, DividerValueProps } from './types';

export type { DividerProps, DividerValueProps };
export default Divider;
